import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=bd43ce1e&scoped=true&"
import script from "./inicio.vue?vue&type=script&lang=ts&"
export * from "./inicio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd43ce1e",
  null
  
)

export default component.exports